import React from 'react';

import globalClasses from '../../../App.module.css';

const ParamsList = () => {
    return (
        <ul className={globalClasses.ParamsList}>
            <li>
                <b>outcomeId </b>
                <i>
                    the id of the outcome that needs to be formatted <b>*</b>
                </i>
            </li>
            <li>
                <b>betOffer </b>
                <i>
                    object with the betOffer of that outcome <b>*</b>
                </i>
            </li>
            <li>
                <b>event </b> <i>object with the event of that outcome</i>
            </li>
            <li>
                <b>selections </b>{' '}
                <i>object with the horse racing selections</i>
            </li>
            <li>
                <b>getTranslationCallback </b>
                <i>
                    a callback that will return the translated text based on
                    some keys
                </i>
            </li>
            <li>
                <b>enableHandicapPickem </b>
                <i>
                    boolean - decides if a pickem translation should be used
                    instead of 0 for line-based bet offers.
                </i>
            </li>
        </ul>
    );
};

export default ParamsList;
